import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import Axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "./HomeModal.css";
import "react-toastify/dist/ReactToastify.css";
import "./ContactUs.css";

const ContactModal = ({ show, onHide }) => {
    const url = "https://hgs.mediapattern.com/";
    const [isScrolled, setIsScrolled] = useState(false);
    const [isShow, steIsShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleScroll = (e) => {
        if (e.target.scrollTop > 0 && !isScrolled) {
            setIsScrolled(true);
        }
        if (e.target.scrollTop === 0) {
            setIsScrolled(false);
        }
    };
    const handleClick = () => {
        steIsShow(!isShow);
        console.log(isShow);
    };
    const [data, setData] = useState({
        Username: "",
        Email: "",
        Mobile: "",
        City: "",
        Grade: "",
        Message: "",
        school: "anangpur",
    });
    function handle(e) {
        const newdata = { ...data };
        newdata[e.target.id] = e.target.value;
        setData(newdata);        
    }
    function submit(e) {
        e.preventDefault();
        setLoading(true);
        Axios.post(url, {
            username: data.Username,
            email: data.Email,
            mobile: data.Mobile,
            city: data.City,
            grade: data.Grade,
            message: data.Message,
            school: data.school,
        }).then((res) => {
            if (res.data.message === "Email Sent") {
                setSuccess(true);
                setLoading(false);
                toast.success(
                    "Your Query has been recieved successfully, we will contact you",
                    {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    }
                );
                setData({
                    Username: "",
                    Email: "",
                    Mobile: "",
                    City: "",
                    Grade: "",
                    Message: "",
                    school: "anangpur",
                });
            } else {
                setLoading(false);
            }
        });
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            className="home-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backdropFilter: "blur(0px)", zIndex: "9999999", background: "rgb(2 2 2 / 92%)" }}
        >
            <Modal.Header closeButton></Modal.Header>


            <form onSubmit={(e) => submit(e)}>
                <div className="mt-4">
                    <div className="form-main form-main-modal">
                        <div className="input-container mt-3">
                            <label>Full Name</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="Username"
                                value={data.Username}
                                className="input-field"
                                type="text"
                                placeholder="Full Name"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="input-container mt-3">
                            <label>Email</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="Email"
                                value={data.Email}
                                className="input-field"
                                type="text"
                                placeholder="Email"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="input-container mt-3">
                            <label>Mobile</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="Mobile"
                                value={data.Mobile}
                                className="input-field"
                                type="tel"
                                placeholder="Mobile"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="input-container mt-3">
                            <label>City</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="City"
                                value={data.City}
                                className="input-field"
                                type="text"
                                placeholder="City"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="input-container mt-3">
                            <label>Grade</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="Grade"
                                value={data.Grade}
                                className="input-field"
                                type="text"
                                placeholder="Grade"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="input-container mt-3">
                            <label>Message</label>
                            <input
                                onChange={(e) => handle(e)}
                                id="Message"
                                value={data.Message}
                                className="input-field"
                                type="text"
                                placeholder="Message"
                                name="usrnm"
                                required
                            />
                        </div>
                        <div className="d-flex justify-content-center align-content-center mt-4">
                            <button
                                disabled={loading}
                                className="btn btn-submit f-2 color-white w-full"
                            >
                                Enquire Now
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default ContactModal;
